import { AxiosInstance, AxiosError } from "axios";
import { showToast } from "../../../components/toast.component";
import { toaster } from "rsuite";

let toastId: string | undefined = undefined;

export class ConnectivityCheck {
  /**
   * @static @function Add() Add interceptor to and instance
   * @param {AxiosInstance} instance Instance of Axios
   * @returns {number} Interceptor Id
   */
  static Add(instance: AxiosInstance): number {
    async function ConnectivityErrorHandler(
      error: AxiosError<{ [key: string]: unknown }>
    ): Promise<unknown> {
      if ((error.toJSON() as any).message === "Network Error" && !toastId) {
        toastId = showToast(
          "Network Connection Error",
          "error",
          "topCenter",
          5000
        );
      }

      throw error;
    }

    return instance.interceptors.response.use((response) => {
      if (toastId) {
        toaster.remove(toastId);
        toastId = undefined;
      }
      return response;
    }, ConnectivityErrorHandler);
  }
  /**
   * @static @function Remove() Eject the interceptor from the Axios instance
   * @param {AxiosInstance} instance Instance of Axios
   * @param {number} id Interceptor Id
   */
  static Remove(instance: AxiosInstance, id: number): void {
    instance.interceptors.response.eject(id);
  }
}
